import {FieldData} from 'rc-field-form/lib/interface';

export interface ResponseError {
  propertyPath: string,
  message: string,
}

export interface ErrorsMessage {
  regexp: string,
  message: string,
}

export interface ErrorsMessages {
  [item: string]: ErrorsMessage[];
}

export const getFormErrorFields = (responseErrors: ResponseError[] | any, errorsMessages: ErrorsMessages) => {
  const fields = [] as FieldData[];

  Array.isArray(responseErrors) && responseErrors.forEach((error) => {
    if (Array.isArray(errorsMessages[error.propertyPath])) {
      errorsMessages[error.propertyPath].forEach((item: ErrorsMessage) => {
        if (error.message.match(item.regexp)) {
          fields.push({
            name: error.propertyPath,
            errors: [item.message],
          });
        }
      });
    }
    if (!fields.find(({name}) => name === error.propertyPath) && error.message) {
      fields.push({
        name: error.propertyPath,
        errors: [error.message],
      });
    }
  });

  return fields;
};

export const getErrorMessage = (e: ResponseError | any, errorMessages: ErrorsMessages) => {
  if (e && e.message) {
    const message = errorMessages[e.message];
    if (message) {
      return message;
    }
    return e.message;
  }
  return 'error';
};
